<div class="modal-header">
  <h4 class="modal-title">แบบสอบถามความพึงพอใจ</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-12">
        <p class="text-center mb-2">แบบสอบถามความพึงพอใจในการใช้งาน</p>
      </div>
      <div class="col-12 text-center mb-3">
        <div id="rate" class="btn-group btn-group-toggle">
          <label class="btn" [class.selected]="commentationDto.rate === 1">
            <input type="radio" (change)="commentationDto.rate = 1" [checked]="commentationDto.rate === 1" name="rate">
            <i class="bi bi-emoji-angry satisfaction-level-1 d-block"></i>
            <span class="rating-number">1</span>
            <span class="d-block">น้อยที่สุด</span>
          </label>
          <label class="btn" [class.selected]="commentationDto.rate === 2">
            <input type="radio" (change)="commentationDto.rate = 2" [checked]="commentationDto.rate === 2" name="rate">
            <i class="bi bi-emoji-frown satisfaction-level-2 d-block"></i>
            <span class="rating-number">2</span>
            <span class="d-block">น้อย</span>
          </label>
          <label class="btn" [class.selected]="commentationDto.rate === 3">
            <input type="radio" (change)="commentationDto.rate = 3" [checked]="commentationDto.rate === 3" name="rate">
            <i class="bi bi-emoji-neutral satisfaction-level-3 d-block"></i>
            <span class="rating-number">3</span>
            <span class="d-block">ปานกลาง</span>
          </label>
          <label class="btn" [class.selected]="commentationDto.rate === 4">
            <input type="radio" (change)="commentationDto.rate = 4" [checked]="commentationDto.rate === 4" name="rate">
            <i class="bi bi-emoji-smile satisfaction-level-4 d-block"></i>
            <span class="rating-number">4</span>
            <span class="d-block">มาก</span>
          </label>
          <label class="btn" [class.selected]="commentationDto.rate === 5">
            <input type="radio" (change)="commentationDto.rate = 5" [checked]="commentationDto.rate === 5" name="rate">
            <i class="bi bi-emoji-laughing satisfaction-level-5 d-block"></i>
            <span class="rating-number">5</span>
            <span class="d-block">มากที่สุด</span>
          </label>
        </div>
      </div>
      <div class="col-12 mb-3">
        <textarea placeholder="ระบุความคิดเห็นเพิ่ม (ถ้ามี)" class="form-control" rows="3"
                  name="comment" id="comment"
                  [(ngModel)]="commentationDto.comment"></textarea>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-center gap-2">
        <button type="button" class="btn btn-custom btn-custom-theme confirm-btn"
                [disabled]="submitting" (click)="sentForm()">
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          ส่งแบบสอบถาม
        </button>
        <button type="button" class="btn btn-custom btn-light confirm-btn"
                [disabled]="submitting" (click)="activeModal.close(false)">
          ยกเลิก
        </button>
      </div>
    </div>
  </div>
</div>
